class ContentSliderParallax {
  constructor(slider) {
    this.slider = slider;
    this.slides = Array.from(slider.children);
    this.factor = parseFloat(slider.dataset.parallaxFactor) || 0.45; // movement intensity (smaller = slower)
    this.lastScroll = 0;
    this.ticking = false;
    this.isMobile = window.innerWidth <= 749;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.slider.addEventListener("scroll", this.onScroll, { passive: true });

    // Add slide change listener to reset transforms
    this.slider.addEventListener("slide-stop", this.onSlideChange.bind(this));

    // Add resize listener to update mobile detection
    window.addEventListener("resize", this.onResize, { passive: true });

    // Initial position
    this.update();
  }

  onResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 749;

    // If mobile state changed, force an update
    if (wasMobile !== this.isMobile) {
      this.update();
    }
  }

  onScroll() {
    this.lastScroll = this.slider.scrollLeft;
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  onSlideChange(event) {
    // Reset transforms after slide change to prevent twitching
    setTimeout(() => {
      this.slides.forEach((slide) => {
        const media = slide.querySelector(
          ".slider__banner-image, .media-wrapper"
        );
        if (!media) return;

        // Force a reflow to ensure smooth transition
        media.style.willChange = "transform";
        media.offsetHeight; // Trigger reflow

        // Update transform immediately
        this.update();
      });
    }, 50); // Small delay to ensure slide transition is complete
  }

  update() {
    const sliderRect = this.slider.getBoundingClientRect();
    const baseLeft = sliderRect.left;
    const sliderWidth = sliderRect.width;

    this.slides.forEach((slide) => {
      // Target the media wrapper / image container inside each slide
      const media = slide.querySelector(
        ".slider__banner-image, .media-wrapper"
      );
      if (!media) return;

      const slideRect = slide.getBoundingClientRect();
      const offset = slideRect.left - baseLeft; // distance from viewport start of slider
      const progress = offset / sliderWidth; // -1 to ... 1

      if (this.isMobile) {
        media.style.transform = "none";
      } else {
        // Parallax effect for desktop
        const translateX =
          progress * this.slider.offsetWidth * this.factor * -1;
        media.style.transform = `translateX(${translateX}px)`;
      }

      media.style.willChange = "auto";
    });
  }
}

function initContentSliderParallax() {
  document
    .querySelectorAll('ul[is="scroll-snap-slider"][data-parallax="true"]')
    .forEach((slider) => {
      if (!slider.__parallaxInstance) {
        slider.__parallaxInstance = new ContentSliderParallax(slider);
      }
    });
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initContentSliderParallax);
} else {
  initContentSliderParallax();
}

// Re-init on Shopify theme editor section load events
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", initContentSliderParallax);
}
